var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewoffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.45C13.3593 2.45 16.3552 4.52675 17.8177 7.8125C16.3552 11.0983 13.3593 13.175 10 13.175C6.64068 13.175 3.64477 11.0983 2.18227 7.8125C3.64477 4.52675 6.64068 2.45 10 2.45ZM10 0.5C5.56818 0.5 1.78341 3.53225 0.25 7.8125C1.78341 12.0928 5.56818 15.125 10 15.125C14.4318 15.125 18.2166 12.0928 19.75 7.8125C18.2166 3.53225 14.4318 0.5 10 0.5ZM10 5.375C11.2232 5.375 12.2159 6.467 12.2159 7.8125C12.2159 9.158 11.2232 10.25 10 10.25C8.77682 10.25 7.78409 9.158 7.78409 7.8125C7.78409 6.467 8.77682 5.375 10 5.375ZM10 3.425C7.80182 3.425 6.01136 5.3945 6.01136 7.8125C6.01136 10.2305 7.80182 12.2 10 12.2C12.1982 12.2 13.9886 10.2305 13.9886 7.8125C13.9886 5.3945 12.1982 3.425 10 3.425Z",
    fill: "#CB202D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewoffer);
export default __webpack_public_path__ + "static/media/viewoffer.a92893a84e9d8674e3e00a8c9a896190.svg";
export { ForwardRef as ReactComponent };